import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Landing from "@/pages/Landing";
import Analyze from "@/pages/Analyze";
import ReportPage from "@/pages/ReportPage";
import Upgrade from "@/pages/Upgrade";
import { Toaster } from "sonner";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/analyze" element={<Analyze />} />
          <Route path="/r/:id" element={<ReportPage />} />
          <Route path="/upgrade" element={<Upgrade />} />
        </Routes>
      </BrowserRouter>
      <Toaster richColors position="top-center" />
    </div>
  );
}

export default App;
